/* eslint-disable no-underscore-dangle */
import L from 'leaflet';
import 'mapbox-gl';
import 'mapbox-gl-leaflet';

/**
 * Custom MapBoxGL that sets the layer on the right pane and with the right opacity.
 */
if (!L.MapboxGL) {
  throw new Error('la librería mapbox-gl-leaflet no está cargado correctamente.');
}
class CustomMapBoxGL extends L.MapboxGL {
  constructor(options) {
    super(options);
    this.options = {
      updateInterval: 32,
      padding: 0.1,
      interactive: false,
      pane: 'overlayPane',
      attribution: null,
      opacity: 1,
      ...options
    };
  }

  onAdd(map) {
    if (!this._container) {
      this._initContainer();
    }
    map.getPane(this.options.pane).appendChild(this._container);
    this._initGL();
    this._offset = this._map.containerPointToLayerPoint([0, 0]);

    if (map.options.zoomAnimation) {
      L.DomEvent.on(map._proxy, L.DomUtil.TRANSITION_END, this._transitionEnd, this);
    }

    // Synchronize canvas position with move and zoom events
    map.on('move', this._onMapMove, this);
    map.on('zoom', this._onMapMove, this);

    this._onMapMove(); // Initial position update
  }

  onRemove(map) {
    if (this._map._proxy && this._map.options.zoomAnimation) {
      L.DomEvent.off(this._map._proxy, L.DomUtil.TRANSITION_END, this._transitionEnd, this);
    }
    map.getPane(this.options.pane).removeChild(this._container);

    // Disconnect events
    map.off('move', this._onMapMove, this);
    map.off('zoom', this._onMapMove, this);

    this._glMap.remove();
    this._glMap = null;
  }

  _initContainer() {
    if (this._container) return;
    const container = L.DomUtil.create('div', 'leaflet-gl-layer');
    this._container = container;

    const size = this._map.getSize();
    const paddingOffset = size.multiplyBy(this.options.padding);
    container.style.width = `${size.x}px`;
    container.style.height = `${size.y}px`;
    if (this.options.opacity < 1) {
      container.style.opacity = this.options.opacity;
    }

    const topLeft = this._map.containerPointToLayerPoint([0, 0]).subtract(paddingOffset);
    L.DomUtil.setPosition(container, topLeft);
  }

  _onMapMove() {
    if (!this._container || !this._glMap) return;

    const center = this._map.getCenter();
    const zoom = this._map.getZoom();

    this._glMap.easeTo({
      center: [center.lng, center.lat],
      zoom: zoom - 1,
      duration: 300 // Duración en milisegundos
    });
  }

  setOpacity(opacity) {
    this.options.opacity = opacity;
    if (this._container) {
      this._container.style.opacity = opacity;
    }
  }
}

const customMapBoxGL = opts => new CustomMapBoxGL(opts);

export default customMapBoxGL;
